/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import ServiceCardDownloader from '../../components/ServiceCardDownloader/ServiceCardDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch/fetch.server';
import agentConfig from './agent';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';

import v from './validators';
import { ListaUrzedow } from '../urzad/ListaUrzedow';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const agentDict = {
  agentName: {
    label: 'Imię i nazwisko:',
    editable: true,
  },
  agentMotionAddress: {
    label: 'Adres do korespondencji:',
    editable: true,
    type: 'textarea',
  },
  agentPhoneNumber: {
    label: 'Tel. kontaktowy:',
    editable: true,
  },

};

const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
};

const OtherDict = {
  TrashSize: {
    label: 'Docelowa rzędna składowiska odpadów',
    editable: true,
    type: 'textarea',
  },
  TrashPerYear: {
    label: 'Roczną i całkowita ilość składowanych odpadów oraz rodzaje składowanych odpadów',
    editable: true,
    type: 'textarea',
  },
  TrashType: {
    label: 'Sposób gromadzenia, oczyszczania i odprowadzania ścieków',
    editable: true,
    type: 'textarea',
  },
  TrashGas: {
    label: 'Sposób gromadzenia, oczyszczania i wykorzystywania lub unieszkodliwiania gazu składowiskowego',
    editable: true,
    type: 'textarea',
  },
};

const InfrastructureNeeds = {
  BuildTypeName: {
    label: 'Opis inwestycji',
    editable: true,
    type: 'textarea',
  },
  BuildTypeType: {
    label: 'Przeznaczenie obiektu',
    editable: true,
    type: 'textarea',
  },
  Water: {
    label: 'Woda (średnio) [m3/miesiąc]',
    editable: true,
    type: 'textarea',
  },
  WaterMax: {
    label: 'Woda (max) [m3/dobę]',
    editable: true,
    type: 'textarea',
  },
  Energy: {
    label: 'Energia elektryczna',
    editable: true,
    type: 'textarea',
  },
  Heat: {
    label: 'Zaopatrzenie w ciepło',
    editable: true,
    type: 'textarea',
  },
  Sewege: {
    label: 'Sposób odprowadzania lub oczyszczania ścieków',
    editable: true,
    type: 'textarea',
  },
  Other: {
    label: 'Inne potrzeby',
    editable: true,
    type: 'textarea',
  },
  Trash: {
    label: 'Sposób unieszkodliwiania odpadów',
    editable: true,
    type: 'textarea',
  },
  changeDesc: {
    label: 'Opis istniejącego sposobu zagospodarowania terenu oraz planowane zagospodarowania terenu',
    editable: true,
    type: 'textarea',
  },
  projectDesc: {
    label: 'Opis przeznaczenia i gabaryty projektowanych obiektów budowlanych',
    editable: true,
    type: 'textarea',
  },
  investCharacteristics: {
    label: 'Charakterystyczne parametry techniczne inwestycji',
    editable: true,
    type: 'textarea',
  },
  environmentInfluence: {
    label: 'Dane charakteryzujące wpływ inwestycji na środowisko lub wskazanie poprzedzającej niniejszy wniosek decyzji środowiskowej',
    editable: true,
    type: 'textarea',
  },
};

class WniosekULICP extends React.Component {
  state = {
    info: {
      agentAdd: 'NIE',
      agentName: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    DecisionData: {
      AddressCity: null,
      AddressStreet: null,
      AddressFlat: null,
      AddressNumber: null,
      AddressZipCode: null,
    },
    InfrastructureNeeds: {
      BuildTypeName: null,
      BuildTypeType: null,
      Water: null,
      WaterMax: null,
      Energy: null,
      Sewege: null,
      Heat: null,
      Trash: null,
      Other: null,
      changeDesc: null,
      projectDesc: null,
      investCharacteristics: null,
      environmentInfluence: null,
    },
    OtherAmounts: {
      TrashSize: null,
      TrashPerYear: null,
      TrashType: null,
      TrashGas: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AddressCity: [v.NotNull],
    AddressStreet: [v.NotNull],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull],
    BuildTypeName: [v.NotNull],
    BuildTypeType: [v.NotNull],
    Water: [v.NotNull],
    WaterMax: [v.NotNull],
    Energy: [v.NotNull],
    Sewege: [v.NotNull],
    Heat: [v.NotNull],
    Trash: [v.NotNull],
    Other: [v.NotNull],
    changeDesc: [v.NotNull],
    projectDesc: [v.NotNull],
    investCharacteristics: [v.NotNull],
    environmentInfluence: [v.NotNull],
    agentAdd: [v.NotSelected],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {

        this.setState({
          eserviceDistrict: resp
        })
      });

    this.setState({ isMounted: true });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  render_info = (group, key) => (
    <span>
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  getLandDevelExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Powierzchnia przeznaczona do przekształcenia w wyniku realizacji inwestycji - powierzchnię parkingów, dróg dojazdowych, chodników, placów budowy, placów składowych, zbiorników, inne powierzchnie utwardzone czy płaty roślinności, które zostaną usunięte, a teren urządzony<br />
      Opis dotychczasowego zagospodarowaniu terenu oraz projektowane zmiany - rozbiórka obiektów istniejących, zmiana ukształtowania terenu, np. likwidacja istniejącej zieleni, zmiana istniejącej nawierzchni, przebudowa istniejącego uzbrojenia terenu lub inne
    </p>
  );

  getRoadExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Wjazd na drogę - istniejący, projektowany<br />
      Parkowanie - liczba stanowisk postojowych ogółem, w tym ilość stanowisk projektowanych; rodzaj pojazdów
    </p>
  )

  getIntendedBuildTypeExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Opis - budowa, rozbudowa lub nadbudowa obiektu budowlanego, zmiana sposobu użytkowania obiektu budowlanego lub jego części, wykonanie innych robót budowanych, zamiana sposobu użytkowania terenu. <br />
      Przeznaczenie - zabudowa mieszkaniowa jedno/wielorodzinna, usługowa, mieszkaniowo – usługowa, zagrodowa, produkcyjna.
    </p>
  );

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </p>
  )

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }


  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['DecisionData', 'OtherAmounts', 'InfrastructureNeeds', 'info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      DecisionData: {
        AddressCity: 'test',
        AddressStreet: 'test',
        AddressFlat: 'test',
        AddressNumber: 'test',
        AddressZipCode: 'test',
      },
      InfrastructureNeeds: {
        BuildTypeName: 'test',
        BuildTypeType: 'test',
        Water: 'test',
        WaterMax: 'test',
        Energy: 'test',
        Sewege: 'test',
        Heat: 'test',
        Trash: 'test',
        Other: 'test',
        changeDesc: 'test',
        projectDesc: 'test',
        investCharacteristics: 'test',
        environmentInfluence: 'test',
      },
      OtherAmounts: {
        TrashSize: 'test',
        TrashPerYear: 'test',
        TrashType: 'test',
        TrashGas: 'test',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          DecisionData: { ...this.state.DecisionData },
          InfrastructureNeeds: { ...this.state.InfrastructureNeeds },
          OtherAmounts: { ...this.state.OtherAmounts },
          info: { ...this.state.info },
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>

        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Adres'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </DecisionContainer>

        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          /> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'2. Charakterystyka inwestycji'}
          data={this.state.InfrastructureNeeds}
          errors={this.state.errors}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          formDict={InfrastructureNeeds}
          onChange={e => this.onChange(e, 'InfrastructureNeeds')}
        />

        <DecisionContainer
          title={'3. W przypadku lokalizacji składowiska odpadów '}
          data={this.state.OtherAmounts}
          errors={this.state.errors}
          formDict={OtherDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'OtherAmounts')}
        />

        <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p>Do wniosku o wydanie decyzji należy załączyć:</p>
              <ul>
                <li>Poświadczoną przez właściwy organ kopię mapy zasadniczej/katastralnej1 w skali 1:500, 1:1000 (lub 1:2 000 jedynie w przypadku inwestycji liniowych), przyjętej do państwowego zasobu geodezyjnego i kartograficznego obejmującej przewidywany teren, na którym będzie realizowana inwestycja oraz obejmująca obszar, na który będzie oddziaływała inwestycja;</li>
                <li>Kserokopię ww. poświadczonej przez właściwy organ kopii mapy zasadniczej/katastralnej w skali 1:500, 1:1000 (lub 1:2 000 w przypadku inwestycji liniowych), przyjętej do państwowego zasobu geodezyjnego i kartograficznego z oznaczeniem granic terenu objętego wnioskiem;</li>
                <li>Dowód uiszczenia opłaty skarbowej w wysokości:
                  <br />598 zł - za wydanie decyzji o ustalenie lokalizacji inwestycji celu publicznego
                  <br />UWAGA: Nie podlega opłacie skarbowej wydanie decyzji na wniosek właściciela lub użytkownika wieczystego terenu, którego wniosek dotyczy.
                  <br />17 zł - za dokument stwierdzający udzielenie pełnomocnictw.</li>
              </ul>
            </div>
          </div>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
              <ServiceCardDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
              : null}
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

WniosekULICP.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(WniosekULICP),
);



// WEBPACK FOOTER //
// src/routes/eservices/WniosekULICP.js